import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, projectExpense }) =>
    present(
      repository
        .saveProjectExpense(project, projectExpense)
        .then((savedProjectExpense) => ({
          project,
          projectExpense: savedProjectExpense,
        }))
        .catch(() => Promise.reject({ project, projectExpense })),
    );
}

export type { Interactor };

export { createInteractor };
